





import { Component, Vue } from 'vue-property-decorator';
import MarkupWrapper from './Wrapper.vue';

@Component({
  components: {
    MarkupWrapper,
  },
})
export default class ComponentsMarkupPadded extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/markup/WrapperPadded.vue